import React                         from 'react';
import { Provider as StoreProvider } from 'react-redux';

import { ThemeAppProvider          } from 'src/providers/theme';
import { AlertAppProvider          } from 'src/providers/alert';
import { AppRouterProvider         } from 'src/providers/routing';
import { CameraInputProvider       } from './providers/camera-input-provider';

import { store                     } from 'src/store';

import 'src/assets/fonts/font.css';



function App() {
  return (
    <StoreProvider store={store}>
      <ThemeAppProvider>
        <AlertAppProvider>
          <CameraInputProvider>
            <AppRouterProvider />
          </CameraInputProvider>
        </AlertAppProvider>
      </ThemeAppProvider>
    </StoreProvider>
  );
}

export default App;
